/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: heling.zhang
 * @Date: 2020-10-26 11:23:23
 * @LastEditors: heling.zhang
 * @LastEditTime: 2020-10-26 13:36:47
 */
import newVue from "../main";
import axios from "axios";
import qs from "qs"; // 序列化请求数据
import {showToast, setCookie} from "../common/js/assist";

var baseUrl = "";
if (process.env.NODE_ENV == "development") {
  //无用户版
  // baseUrl = "https://saastest.hdwbcloud.com/api"
  //有用户版
  // baseUrl = "https://kmgzj.hdwbcloud.com/api"
  baseUrl = "http://192.168.10.158:20033/api";
} else if (process.env.NODE_ENV == "production") {
  baseUrl = BASEURL + "/api";
}
const axios_instance = axios.create({
  // 基础url前缀
  baseURL: baseUrl,
  // 请求头信息
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    Accept: "application/json",
  },
  // 设置超时时间
  timeout: 10000,
  // 携带凭证
  // 返回数据类型
  responseType: "json",
});
// 添加请求拦截器
axios_instance.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 添加响应拦截器
axios_instance.interceptors.response.use(
  response => {
    if (response.data.status != 1) {
      if (response.data.status == 405) {
        showToast("登录已失效");
        localStorage.clear();
        if (JSON.parse(sessionStorage.getItem("base_info")).pc_login_show.length == 2) {
          //微信扫码登录&&邮箱验证码登录
        } else {
          if (JSON.parse(sessionStorage.getItem("base_info")).pc_login_show.includes("11")) {
            //微信扫码登录
            setCookie("wx_scan_rurl", window.location.href, 5);
            window.location.href = window.location.origin + "/wx_oauth_w";
          } else {
            //邮箱验证码登录
            newVue.$store.commit("show_login", true);
          }
        }
      } else if (response.data.status == 0) {
        showToast(response.data.msg);
      }
    }
    if (response.data.status == 1 || response.config.needRes) {
      return response.data;
    }
  },
  error => {
    console.log(error);
    if (error.config.needRes) {
      return Promise.reject(error);
    }
  },
);
export default function (url = "", data = {}, type = "GET", otherConfig = {}) {
  type = type.toUpperCase();
  return new Promise((resolve, reject) => {
    if (type === "GET") {
      var options = {
        url: url,
        method: "get",
        params: data,
      };
    } else if (type === "POST") {
      var options = {
        url: url,
        method: "post",
        data: qs.stringify(data),
      };
    }
    axios_instance({
      ...options,
      ...otherConfig,
    })
    .then(function (res) {
      if (res)
        resolve(res);
    });
  });
};



// WEBPACK FOOTER //
// ./src/http/api.js